module.exports = __webpack_public_path__ + "static/media/card-placeholder_678.d305aec2.svg";